import * as React from 'react';
export function useInitToastStacksApiByPlacement() {
  const bottomCenterStackApi = React.useState([]);
  const bottomRightStackApi = React.useState([]);
  const topCenterStackApi = React.useState([]);
  const topRightStackApi = React.useState([]);
  return React.useMemo(() => ({
    'bottom-center': bottomCenterStackApi,
    'bottom-right': bottomRightStackApi,
    'top-center': topCenterStackApi,
    'top-right': topRightStackApi
  }), [bottomCenterStackApi, bottomRightStackApi, topCenterStackApi, topRightStackApi]);
}